<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">Legal</span>
      <h1 class="page-title">Terms of Service</h1>
      <p class="page-subtitle">Last updated: January 2026</p>
    </div>

    <div class="content-block">
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using Quick Indexing Tool, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not use our service.</p>
    </div>

    <div class="content-block">
      <h2>2. Service Description</h2>
      <p>Quick Indexing Tool provides URL indexing services to help web pages get discovered by search engines faster. We do not guarantee specific indexing results, as final indexing depends on search engine algorithms and content quality.</p>
    </div>

    <div class="content-block">
      <h2>3. Acceptable Use</h2>
      <p>You agree not to use the service to:</p>
      <ul class="content-list">
        <li>Submit URLs containing illegal, harmful, or malicious content</li>
        <li>Submit URLs you do not own or have permission to submit</li>
        <li>Attempt to abuse, hack, or disrupt our systems</li>
        <li>Resell or redistribute our service without written permission</li>
        <li>Submit spam, phishing, or deceptive content</li>
      </ul>
    </div>

    <div class="content-block">
      <h2>4. Credits and Payments</h2>
      <p>Credits purchased through our service are non-transferable. Refunds are available for unused credits within 30 days of purchase. We reserve the right to modify pricing with reasonable notice.</p>
    </div>

    <div class="content-block">
      <h2>5. Account Termination</h2>
      <p>We reserve the right to suspend or terminate accounts that violate these terms or engage in abusive behavior. Unused credits will be forfeited upon termination for cause.</p>
    </div>

    <div class="content-block">
      <h2>6. Limitation of Liability</h2>
      <p>Quick Indexing Tool shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.</p>
    </div>

    <div class="content-block">
      <h2>7. Changes to Terms</h2>
      <p>We reserve the right to modify these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>
    </div>

    <div class="content-block">
      <h2>8. Contact</h2>
      <p>For questions about these terms, contact us at <a href="mailto:support@quickindexingtool.com">support&#64;quickindexingtool.com</a>.</p>
    </div>
  </div>
</div>
